import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["menu"]

    connect() {
        // Close dropdown when clicking outside
        document.addEventListener("click", this.closeIfClickedOutside.bind(this))
    }

    disconnect() {
        document.removeEventListener("click", this.closeIfClickedOutside.bind(this))
    }

    toggle(event) {
        event.stopPropagation()
        this.menuTarget.classList.toggle("hidden")
    }

    hide() {
        this.menuTarget.classList.add("hidden")
    }

    closeIfClickedOutside(event) {
        if (!this.element.contains(event.target) && !this.menuTarget.classList.contains("hidden")) {
            this.hide()
        }
    }
}